import { ApplicationResultContent } from '../../components/ApplicationResultContent';

type ApplicationWaitlistedProps = { 
  programName: string;
  backgroundImage?: string;
};

export const ApplicationWaitlisted = (props: ApplicationWaitlistedProps) => {
  const { programName, backgroundImage } = props;
  return (
    <ApplicationResultContent
      title={`You're on the Waitlist for ${programName}`}
      backgroundImage={backgroundImage}
      description={
        <div className='flex flex-col gap-4'>
          <div>
            Thank you for applying to {programName}! We were inspired by your passion for making a
            difference.
          </div>
          <div>
            All spots for this round have been filled, and competition was incredibly strong - but
            your application stood out. While we can't offer you a confirmed spot right now, you've
            been added to the waitlist.
          </div>
          <div>
            If any openings come up in the first two weeks, we'll be in touch right away to explore
            next steps with you.
          </div>
        </div>
      }
    />
  );
};
